// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiePreferenceModal_container__1ZTA_","buttons":"CookiePreferenceModal_buttons__3LqlP","button":"CookiePreferenceModal_button__3kx1E"};